import React, { Component } from 'react';
import styled, { css } from 'styled-components'
import headerImage from './assets/img/header-image.png';
import { ReactComponent as LogoImage } from './assets/img/mmsports_logo_ctq.svg';

import FormSignup from './Components/FormSignup';
import StoreSelector from './Components/StoreSelector';

import ThankYou from './Components/ThankYou';
import ResponseNotice from './Components/ResponseNotice';

const ThemeLight = css`
  background-color: #fff;
  color: #000;

  h1,h2 {
    color: #000;
  }
  .cls-1 {
    fill: #000;
  }
`;
const ThemeDark = css`
  background-color: #000;
  color: #fff;
  
  h1,h2,h3 {
    color: #fff;
  }

  .cls-1 {
    fill: #fff;
  }
`;

const MainContainer = styled.div`
  ${props => (props.step === 'start' ? ThemeDark : ThemeLight)};
  
  text-align: center;
  margin: 0 auto;
  
  h1, h2 {
    margin: 0;
  }
  
  h1 {
    font-size: 34px;
    line-height: 38px;
    margin-bottom: 10px;
  }
  
  h2 {
    font-size: 38px;
    line-height: 48px;
    font-weight: 400;
  }
  
  @media (min-width: 768px) { 
    h1 {
      font-size: 46px;
      line-height: 52px;
    }
  
    h2 {
      font-size: 54px;
      line-height: 62px;
    }
  }

  @media (min-height: 1025px ) {
    h1 {
      font-size: 60px;
      line-height: 68px;
    }
  }
`;
const Header = styled.div`
  line-height: 0;
  overflow: hidden;
  max-height: 195px;

  @media (min-height: 1025px ) {
    max-height: 240px;
  }

  img {
    width: 100%;
    object-fit: cover;
    object-position: 100% 0;
  }
`;
const Content = styled.div`
  padding: 30px 20px 20px;
  color: #000;
  
  @media (min-width: 560px ) {
    padding: 40px 40px 75px;
  }

  @media (min-height: 1025px ) {
    padding: 40px 40px 75px;
  }
`;

const Footer = styled.div`

  @media (min-width: 560px ) {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 15px;
  }

  svg {
    width: 200px;
  }
`;

const stores = [
  {"name":"Eskilstuna","storeId":22},
  {"name":"GBG - Fröunda Torg","storeId":21},
  {"name":"GBG - Kungsgatan","storeId":31},
  {"name":"Gävle","storeId":29},
  {"name":"Jönköping","storeId":27},
  {"name":"Kungsbacka","storeId":26},
  {"name":"Kungälv","storeId":25},
  {"name":"Mall of Scandinavia", "storeId":33},
  {"name":"Malmö - Baltzargatan","storeId":24},
  {"name":"Oslo","storeId":50},
  {"name":"STHLM - Kungsholmen","storeId":30},
  {"name":"STHLM - Sveavägen","storeId":23},
  {"name":"Täby","storeId":34},
  {"name":"Uppsala", "storeId":32},
  {"name":"Örebro","storeId":28},
  {"name":"Swefit Expo 2/11-19","storeId":60},
  {"name":"Köpenhamn","storeId":40}
];

const sweFitContent = {
  "formsignup": {
    "title": {
      "sv": "TÄVLA NU!"
    },
    "text": {
      "sv": "Skriv in din mailadress och ditt telefonnummer. När du registrerat dig är du med och tävlar om en årsförbrukning av XLNT Sports Energidryck! (Vinsten motsvarar 1 burk/dag). Vinnaren kontaktas per mail eller telefon senast 30 november."
    },
    "terms": {
        "sv": "Din integritet är viktig för oss och vi hanterar alltid uppgifter om dig på ett pålitligt och lagligt sätt. Vill du veta mer kan du läsa vår integritetspolicy på mmsports.se"
    },
    form: {
      emailPlaceholder: {
        sv: "Din e-postadress",
        no: "Din e-postadresse"
      },
      phonePlaceholder: {
        sv: "Ditt mobilnummer",
        no: "Ditt mobilnummer"
      },
      register: {
        sv: "Registrera mig",
        no: "Registrer meg"
      },
      invalidEmail: {
        sv: "Ogiltig epostadress",
        no: "Ugyldig e-postadresse"
      },
      alreadyCustomer: {
        sv: "Du är redan registrerad hos oss",
        no: "Du er allerede registrert hos oss"
      },
      error: {
        sv: "Något gick fel, vänligen försök igen eller kontakta butikspersonal",
        no: "Noe gikk galt, prøv igjen eller kontakt butikkpersonalet"
      }
    }
  },
  "thankyou": {
    "title": {
      "sv": "Tack, du är nu med i tävlingen!"
    },
    "description": {
      "sv": "Vi har även lagt till dig i MM Sports medlemsregister"
    },
    "btn": {
      "sv": "Tillbaka"
    },
  },
  "responseNotice": {
    "title": {
      "sv": "Tack, du är nu med i tävlingen!"
    },
    "text": {
      "sv": ""
    },
    "btn": {
      "sv": "Tillbaka"
    },
  },
}

const pageContent = {
  "formsignup": {
    "title": {
      "sv": "Bli medlem hos MM Sports - få 15% rabatt på ditt första köp!",
      "no": "Bli medlem av MM Sports - få 15 % rabatt på ditt første kjøp!",
      "da": "Bliv medlem hos MM Sports – få 15 % rabat på dit første køb!"
    },
    "text": {
      "sv": "<p>Du får 15 % rabatt på ditt första köp när du registrerar dig som medlem. Gäller även på nedsatta priser, men kan ej kombineras med rabattkoder.</p><p><strong>Som medlem får du bland annat:</strong><br>- Digitalt kvitto<br>- Exklusiva erbjudanden & rabattkoder<br>- Förtur till utvalda kampanjer<br>- Information om nyheter & produktlanseringar<br>- Födelsedagsgåva</p>",
      "no": "<p>Du får 15 % rabatt på ditt første kjøp når du registrerer deg som medlem. Kan ikke kombineres med andre rabattkoder.</p><p><strong>Som medlem får du blant annet:</strong><br>- Digital kvittering<br>- Eksklusive tilbud & rabattkoder<br>- Forkjørsrett til utvalgte kampanjer<br>- Informasjon om nyheter & produktlanseringer<br>- Bursdagsgave</p>",
      "da": "<p>Du får 15 % rabat på dit første køb, når du registrerer dig som medlem. Gælder også på nedsatte priser, men kan ikke kombineres med rabatkoder.</p><p><strong>Som medlem får du blandt andet:</strong><br>- Digital kvittering<br>- Eksklusive tilbud og rabatkoder<br>- Prioritetsadgang til udvalgte kampagner<br>- Information om nyheder og produktlanceringer</p>"
    },
    "terms": {
      "sv": "Du godkänner att ta emot mejl och SMS från MM Sports. Du kan när som helst avregistrera dig. Vi värnar alltid om din integritet. Läs mer i vår integritetspolicy på mmsports.se om hur vi hanterar dina uppgifter.",
      "no": "Din integritet er viktig for oss, og vi håndterer alltid informasjonen din på en pålitelig og lovlig måte. Hvis du vil vite mer, kan du lese vår personvernpolicy på mmsports.no",
      "da": "Du accepterer at modtage e-mails og SMS fra MM Sports. Du kan til enhver tid afmelde dig. Dit privatliv er vigtigt for os, og vi behandler altid dine oplysninger på en pålidelig og lovlig måde. Vil du vide mere, kan du læse vores privatlivspolitik på mmsportsstore.dk"
    },
    form: {
      emailPlaceholder: {
        sv: "Din e-postadress",
        no: "Din e-postadresse",
        da: "Din e-mailadresse"
      },
      phonePlaceholder: {
        sv: "Ditt mobilnummer",
        no: "Ditt mobilnummer",
        da: "Dit mobilnummer"
      },
      register: {
        sv: "Registrera mig",
        no: "Registrer meg",
        da: "Tilmeld mig"
      },
      invalidEmail: {
        sv: "Ogiltig epostadress",
        no: "Ugyldig e-postadresse",
        da: "Ugyldig e-mailadresse"
      },
      invalidPhone: {
        sv: "Ogiltigt telefonnummer. Ange som +46XXXXXXXXX eller lämna tomt",
        no: "Ugyldig telefonnummer. Oppgi som +47XXXXXXXX eller la feltet stå tomt",
        da: "Ugyldigt telefonnummer. Angiv som +45XXXXXXXX eller lad feltet være tomt"
      },
      invalidSocialSecurityNumber: {
        sv: "Ogiltigt personnummer. Ange som ååååmmdd-nnnn eller lämna tomt",
        no: "Ugyldig fødselsnummer. Oppgi som ååååmmdd-nnnn eller la feltet stå tomt",
        da: "Ugyldigt personnummer. Angiv som ååååmmdd-nnnn eller lad feltet være tomt"
      },
      alreadyCustomer: {
        sv: "Du är redan registrerad hos oss",
        no: "Du er allerede registrert hos oss",
        da: "Du er allerede registreret hos os"
      },
      error: {
        sv: "Något gick fel, vänligen försök igen eller kontakta butikspersonal",
        no: "Noe gikk galt, prøv igjen eller kontakt butikkpersonalet",
        da: "Noget gik galt, prøv venligst igen eller kontakt butikspersonalet"
      }
    }
  },
  "thankyou": {
    "title": {
      "sv": "Tack, du är nu medlem hos oss!",
      "no": "Takk, du er nå medlem hos oss!",
      "da": "Tak, du er nu medlem hos os!"
    },
    "btn": {
      "sv": "Tillbaka",
      "no": "Tilbake",
      "da": "Tilbage"
    }
  },
  "responseNotice": {
    "title": {
      "sv": "Vad kul, vi ser att du redan är medlem hos oss.",
      "no": "Så gøy, vi ser at du allerede er medlem hos oss.",
      "da": "Hvor dejligt, vi kan se, at du allerede er medlem hos os."
    },
    "text": {
      "sv": "Detta erbjudande gäller endast nya medlemmar. Tack för att du är en lojal kund! Håll utkik i din inkorg för exklusiva erbjudanden och spännande produktlanseringar - före alla andra.",
      "no": "Dette tilbudet gjelder kun nye medlemmer. Takk for at du er en lojal kunde! Følg med i innboksen din for eksklusive tilbud og spennende produktlanseringer – før alle andre.",
      "da": "Dette tilbud gælder kun nye medlemmer. Tak fordi du er en loyal kunde! Hold øje med din indbakke for eksklusive tilbud og spændende produktlanceringer – før alle andre."
    },
    "btn": {
      "sv": "Tillbaka",
      "no": "Tilbake",
      "da": "Tilbage"
    }
  }
}

class App extends Component {
  constructor(props) {
    super(props);

    this.setStep = this.setStep.bind(this);

    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    const storeId = parseInt(params.get('store_id')) || null
    const lang = storeId === 40 ? "da" : "sv";

    if (storeId === 60 ) {
      pageContent.start = sweFitContent.start;
      pageContent.formsignup = sweFitContent.formsignup;
      pageContent.responseNotice = sweFitContent.responseNotice;
      pageContent.thankyou = sweFitContent.thankyou;
    }

    this.state = {
      step: 'formsignup',
      language: lang,
      storeId: storeId
    }
  }

  setStep(step){
    this.setState({
      step: step
    })
  }

  fullscreenMode() {
    const docElm = document.documentElement;

    if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
    } 
    else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen(); 
    }   
  }
  __(content) {
    return content[this.state.language];
  }
  render() {
    let activeStep;
    let {step,language, storeId} = this.state;

    const validStoreId = storeId ? stores.some(el => el.storeId === storeId) : false;
    if (!validStoreId) {
      step = 'storeSelector'
    }
    //this.fullscreenMode();

    switch(step) {
      case 'storeSelector':
        activeStep = <StoreSelector />
        break;
      case 'formsignup':
        activeStep = <FormSignup changeStep={this.setStep} storeId={this.state.storeId} language={language} content={pageContent.formsignup} __={(content) => this.__(content)} />
        break;
      case 'thankyou':
        activeStep = <ThankYou changeStep={this.setStep} storeId={this.state.storeId} language={language} content={pageContent.thankyou} __={(content) => this.__(content)} />
        break;
      case 'responseNotice':
        activeStep = <ResponseNotice changeStep={this.setStep} language={language} content={pageContent.responseNotice} __={(content) => this.__(content)} />
        break;
      default:
        activeStep = null;
    }

    return (
      <MainContainer step={this.state.step} className='App'>
        <Header>
          <img src={headerImage} alt="header" />
        </Header>
        <Content>
          {activeStep}
        </Content>
        <Footer>
          <LogoImage />
        </Footer>
      </MainContainer>
    );
  }
}

export default App;
